var map = {
	"./age_rating_0.svg": 731,
	"./age_rating_12.svg": 732,
	"./age_rating_16.svg": 733,
	"./age_rating_18.svg": 734,
	"./age_rating_7.svg": 735,
	"./app_store.svg": 387,
	"./app_store_full.svg": 736,
	"./appstore.svg": 737,
	"./arrow_xl_l.svg": 738,
	"./arrow_xl_r.svg": 739,
	"./blik.svg": 740,
	"./bluemedia.svg": 741,
	"./calendar.svg": 742,
	"./close.svg": 743,
	"./close_thin.svg": 744,
	"./content_rating_n.svg": 745,
	"./content_rating_p.svg": 746,
	"./content_rating_s.svg": 747,
	"./content_rating_w.svg": 748,
	"./dcb.svg": 749,
	"./device_pc.svg": 750,
	"./device_phone.svg": 751,
	"./device_tablet.svg": 752,
	"./device_tv.svg": 753,
	"./exit_fullscreen.svg": 754,
	"./facebook.svg": 755,
	"./fullscreen-vod.svg": 756,
	"./fullscreen.svg": 757,
	"./google_play_full.svg": 758,
	"./googleplay.svg": 759,
	"./ic_EU.svg": 760,
	"./ic_EU_PL.svg": 761,
	"./ic_adult.svg": 762,
	"./ic_app_store.svg": 763,
	"./ic_arrow_down.svg": 764,
	"./ic_arrow_l.svg": 765,
	"./ic_arrow_r.svg": 766,
	"./ic_auth_facebook.svg": 767,
	"./ic_auth_google.svg": 768,
	"./ic_back.svg": 769,
	"./ic_basket.svg": 770,
	"./ic_bell.svg": 771,
	"./ic_blik.svg": 772,
	"./ic_bluemedia.svg": 773,
	"./ic_clock.svg": 774,
	"./ic_close.svg": 775,
	"./ic_close_thin.svg": 776,
	"./ic_content_info.svg": 777,
	"./ic_delete.svg": 778,
	"./ic_epg_left.svg": 779,
	"./ic_epg_right.svg": 780,
	"./ic_facebook.svg": 781,
	"./ic_favorite.svg": 782,
	"./ic_favorite_border.svg": 783,
	"./ic_favorite_full.svg": 784,
	"./ic_gears.svg": 785,
	"./ic_google.svg": 786,
	"./ic_google_play.svg": 787,
	"./ic_grid.svg": 788,
	"./ic_home.svg": 789,
	"./ic_info.svg": 790,
	"./ic_instagram.svg": 791,
	"./ic_institution.svg": 792,
	"./ic_link_facebook.svg": 793,
	"./ic_link_instagram.svg": 794,
	"./ic_link_pinterest.svg": 795,
	"./ic_link_tiktok.svg": 796,
	"./ic_link_twitter.svg": 797,
	"./ic_list.svg": 798,
	"./ic_lock.svg": 799,
	"./ic_lock_second.svg": 800,
	"./ic_mastercard.svg": 801,
	"./ic_nav_favorite.svg": 802,
	"./ic_nav_kontrast.svg": 803,
	"./ic_nav_profile.svg": 804,
	"./ic_nav_reminder.svg": 805,
	"./ic_nav_search.svg": 806,
	"./ic_operator_orange.svg": 807,
	"./ic_operator_play.svg": 808,
	"./ic_operator_plus.svg": 809,
	"./ic_operator_t_mobile.svg": 810,
	"./ic_pause.svg": 811,
	"./ic_payment_arrow.svg": 812,
	"./ic_phone.svg": 813,
	"./ic_play.svg": 814,
	"./ic_play_xl.svg": 815,
	"./ic_player_fullscreen copy.svg": 816,
	"./ic_player_fullscreen.svg": 817,
	"./ic_player_fullscreen_close.svg": 818,
	"./ic_player_minus_15.svg": 819,
	"./ic_player_play.svg": 820,
	"./ic_player_plus_15.svg": 821,
	"./ic_player_settings.svg": 822,
	"./ic_player_stop.svg": 823,
	"./ic_player_volume_off.svg": 824,
	"./ic_player_volume_on.svg": 825,
	"./ic_profile.svg": 826,
	"./ic_rec.svg": 827,
	"./ic_reminder.svg": 828,
	"./ic_search.svg": 829,
	"./ic_share.svg": 830,
	"./ic_tick.svg": 831,
	"./ic_tick_circle.svg": 832,
	"./ic_trash.svg": 833,
	"./ic_tv.svg": 834,
	"./ic_twitter.svg": 835,
	"./ic_vimeo.svg": 836,
	"./ic_visa.svg": 837,
	"./ic_vod_favorite.svg": 838,
	"./ic_wcag_animation.svg": 839,
	"./ic_wcag_animation_play.svg": 840,
	"./ic_wcag_contrast.svg": 841,
	"./ic_wcag_disability.svg": 842,
	"./ic_wcag_reset.svg": 843,
	"./ic_wcag_text_large.svg": 844,
	"./ic_wcag_text_medium.svg": 845,
	"./ic_wcag_text_small.svg": 846,
	"./ic_youtube.svg": 847,
	"./icon_back_mobile.svg": 848,
	"./icon_mobile_menu_arrow_down.svg": 849,
	"./logo_ckf.svg": 390,
	"./logo_header.svg": 668,
	"./logo_zsww.svg": 850,
	"./mc.svg": 851,
	"./minimalize.svg": 852,
	"./new_ic_bell.svg": 853,
	"./nexgentv.svg": 388,
	"./next.svg": 854,
	"./pause.svg": 855,
	"./placeholder.svg": 856,
	"./play.svg": 857,
	"./previous.svg": 858,
	"./redcarpet_logo.svg": 239,
	"./seek_15_next.svg": 859,
	"./seek_15_prev.svg": 860,
	"./settings.svg": 861,
	"./star_empty.svg": 862,
	"./star_full.svg": 863,
	"./test/search_icon.svg": 864,
	"./test/share_icon.svg": 865,
	"./tick.svg": 866,
	"./triangle-border.svg": 391,
	"./triangle.svg": 867,
	"./underline.svg": 868,
	"./vectra_logo.svg": 869,
	"./vectra_new_logo.svg": 870,
	"./visa.svg": 871,
	"./vod_heart.svg": 872,
	"./vod_heart_full.svg": 873,
	"./vod_play.svg": 874,
	"./volume.svg": 875,
	"./volume_off.svg": 876,
	"./w_logo.svg": 877,
	"./wajda_logo.svg": 878
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 730;